<h3 mat-dialog-title>Converting PDF to Images</h3>

<div mat-dialog-content>
    <div>
        The PDF you uploaded is being converted to images for easier access on the task list.
    </div>
    <div style="padding-top: 10px;">
        It make take several minutes for the images to appear in the dialog, you may need to close and reopen to see the images.
    </div>
</div>

<div mat-dialog-actions class="fx-row-space-evenly-center">
  <button class="mat-raised-button" (click)="close()">Ok</button>
</div>